<div id="inicio" style="color: white; margin-bottom: -30px;">s</div>
<app-template >

    <!-- FAD MASIVO DESKTOP -->
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="main-fad-personal">
            <h1>
                <p>FAD® PERSONAL</p>
            </h1>
        </div>

        <div class="you-should">
            <div class="container max-width">
                <div class="picture">
                    <img src="assets/images/suscripciones.png" alt="Suscripciones">
                </div>
                <div class="text">
                    <h2><p class="principal">
                        Con FAD® personal <br> puedes elegir entre <br> <span>suscripción mensual o <br> plan prepago con <br> vigencia anual:</span>
                    </p></h2>
                    <p class="secondary">
                        Puedes cancelar tu suscripción mensual en cualquier momento.
                    </p>
                </div>
            </div>
        </div>

        <div class="options-suscriptions">
            <div class="container max-width">
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/suscripcion_mensual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Suscripción <br> <span>Mensual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic">
                                <p class="light">
                                    Incluye proceso patentado:
                                </p>
                                <p class="bold">
                                    Videofirma, videoacuerdo, constancia de conservación, verificación por número de teléfono
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Soporte:
                                </p>
                                <p class="bold">
                                    N1 Call center de Lunes a Viernes de 8am a 8pm.
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Incluye:
                                </p>
                                <p class="bold">
                                    Sólo app nativa (iOS y Android)
                                    <br><strong style="font-size: 18px">No incluye opción a compra de SDK o API</strong>
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transacción:
                                </p>
                                <p class="bold">
                                    Videofirma + videoacuerdo + constancia de conservación + verificación por número de
                                    teléfono
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Con costo extra
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Método de pago:
                                </p>
                                <p class="bold">
                                    Tarjeta de crédito o débito
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_mensual_personal" class="option no-cart dark" (click)="form(6)">
                            <p>CONTACTA A UN ASESOR</p>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <mat-card>
                        <div class="image">
                            <img src="assets/images/suscripcion_anual.png" alt="FAD Personal">
                            <div class="text">
                                <p>Prepago con<br><span>Vigencia anual</span></p>
                            </div>
                        </div>
                        <mat-card-content>
                            <div class="characteristic" style="padding-top: 60px;">
                                <p class="light">
                                    Usuarios incluidos:
                                </p>
                                <p class="bold">
                                    1
                                    <br>Usuario
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Número de transacciones:
                                </p>
                                <p class="bold">
                                    Planes de 10, 20, 50, 100, 200, 500 o 1,000 firmas
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Vigencia de transacciones:
                                </p>
                                <p class="bold">
                                    Anual
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Tipo de transacción:
                                </p>
                                <p class="bold">
                                    Videofirma + videoacuerdo + constancia de conservación + verificación por número de
                                    teléfono
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Add-Ons:
                                </p>
                                <p class="bold">
                                    Con costo extra
                                </p>
                            </div>

                            <div class="characteristic">
                                <p class="light">
                                    Método de pago:
                                </p>
                                <p class="bold">
                                    Tarjeta de crédito o débito
                                </p>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    <div class="pricing">
                        <div id="comprar_anual_personal" class="option no-cart dark" (click)="form(7)">
                            <p>CONTACTA A UN ASESOR</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="add-ons">
            <p class="title max-width">
                Tanto en la Suscripción mensual como en el Plan prepago <br>
                puedes agregar las siguientes <span>Funcionalidades extra (Add-Ons)**:</span>
            </p>
            <p style="margin: 20px 0 0; text-align: center; font-size: 20px; margin-top: -15px;">
                <a href="https://api.whatsapp.com/send?phone=5215578537351" style="font-weight: bold;color: var(--light-gray-color); text-decoration: none; cursor: pointer;">** Para la compra de Funcionalidades extra (Add-Ons) solicítalos con tu asesor de ventas con costo
                    extra.</a>
                <br>
                <span style="color: var(--light-gray-color);" *ngIf="this.sessionService.getCountryData()">* Más impuestos locales.</span>
            </p>
            <div class="list max-width">
                <div class="left">
                    <p class="title">
                        Funcionalidades extra
                    </p>
                    <div class="table">

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/foto_ine.png" alt="Foto INE">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación</p>
                                <p class="text-item">Fotografía de la identificación por ambos lados</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/otp_whatsap.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">OTP vía WhatsApp</p>
                                <p class="text-item">Envío de código de un sólo uso por WhatsApp, para que el firmante
                                    abra
                                    el documento a firmar en la app móvil o web</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/blockchain.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Constancia de conservación en Blockchain</p>
                                <p class="text-item">Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="image">
                                <img src="assets/images/version_web.png" alt="SMS">
                            </div>
                            <div class="data">
                                <p class="title-item">Versión WEB</p>
                                <p class="text-item">El firmante puede realizar la firma de documentos desde cualquier
                                    navegador móvil sin descargar ninguna aplicación</p>
                            </div>
                        </div>


                        <div class="row">
                            <div class="image">
                                <img src="assets/images/fotoine_firma.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video.png" alt="Ine y Firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con video
                                    acuerdo</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico, más una comparación entre la foto del rostro
                                    plasmada en el ID y una imagen del rostro del firmante durante el
                                    videoacuerdo</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_videofirma.png" alt="Ine, video y firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con
                                    videofirma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico, más una comparación entre la foto del rostro
                                    plasmada en el ID y una imagen del rostro del firmante durante
                                    la videofirma</p>
                            </div>
                        </div>

                        <div class="row big">
                            <div class="image">
                                <img src="assets/images/ine_firma_video_validacion.png"
                                     alt="Ine, comparación de firma y video firma">
                            </div>
                            <div class="data">
                                <p class="title-item">Captura de identificación + validación de firma + comparación
                                    facial con video
                                    acuerdo + comparación facial con videofirma</p>
                                <p class="text-item">Comparación entre la firma plasmada en el ID y la firma hecha con
                                    el
                                    dedo o lápiz óptico; comparación entre la foto del rostro plasmada en el
                                    ID y una imagen del rostro del firmante durante el videoacuerdo;
                                    comparación entre la foto del rostro plasmada en el ID y
                                    una imagen del rostro del firmante durante el videofirma</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="do-you-wish">
            <p class="title max-width">
                ¿Deseas adquirir una <span>Suscripción mensual</span> <br>
                o un <span>Plan prepago</span> ?
            </p>
            <div class="options max-width">
                <div class="item">
                    <img src="assets/images/suscripcion_mensual_personal.png" alt="Suscripción Mensual">
                    <div class="text">
                        <p>Suscripción <br><span>Mensual</span></p>
                    </div>
                </div>

                <div class="item">
                    <img src="assets/images/suscripcion_anual_2.png" alt="Suscripción Anual">
                    <div class="text">
                        <p>Prepago con <br><span>Vigencia Anual</span></p>
                    
                    </div>
                </div>
            </div>
        </div>
        <div class="pricing-list-bottom">
            <div class="container max-width">
                <div class="item">
                    <div id="comprar_mensual_resumen" class="option no-cart dark" (click)="form(6)">
                        <p> COTIZA HOY</p>
                    </div>
                </div>
                <div class="item">
                    <div id="comprar_anual_resumen" class="option no-cart dark" (click)="form(7)">
                        <p>COTIZA HOY</p>
                    </div>
                </div>
            </div>
        </div>
        <div><p id="contact-cotizar" style="color: white;">ancla</p></div>
        <div>
            <div class="options-suscriptions-form" *ngIf="contactForm === 6 || contactForm === 7">
                <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                <p class="title max-width" *ngIf="contactForm === 6">
                    Ayúdanos a completar el formulario para <b>cotizar tu plan <br>de suscripción mensual</b>
                </p>
                <p class="title max-width" *ngIf="contactForm === 7">
                    Ayúdanos a completar el formulario para <b>cotizar tu plan <br>de prepago con vigencia anual</b>
                </p>
                <div class="max-width" *ngIf="contactForm === 6">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="max-width" *ngIf="contactForm === 7">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->

    <div  class="fad-movil" *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
                <img class="img-prin" src="assets/images/m/personalfotos.png">
            </div>

            <div class="content-res">
                <h1>FAD®<br><span>PERSONAL</span><br></h1>
                <hr>
                <h2><p class="text">
                    Con FAD® personal puedes <strong>elegir entre suscripción mensual o plan prepago con vigencia
                    anual</strong> y puedes cancelar en cualquier momento.
                </p></h2>
            </div>

            <div class="box-light">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Suscripción</p><span>mensual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
                            <p>Videofirma + Videoacuerdo + Constancia de conservación</p>
                            <p>N1 Call center de Lunes a Viernes de 8am a 8pm.</p>
                            <p>Sólo App Nativa (iOS y Android)
                            <br><strong style="font-size: 11px">No incluye opción a compra de SDK o API</strong></p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_personal_movil" class="btn-back" (click)="form(6)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">Plan prepago con </p>
                        <span>vigencia anual</span><br>
                    </div>
                    <div class="box-product">
                        <div class="description" style="padding-bottom: 0px;">
                        
                            <p>Transacciones<br><strong>10, 20, 50, 100, 500 o 1000</strong></p>
                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_personal_movil" class="btn-back" (click)="form(7)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-general">

                <div class="content-res">
                    Agrega<br><strong>funcionalidades extra a tu paquete FAD®</strong><br>
                </div>

                <div class="icon">
                    <div class="icon2"></div>
                </div>
                <p class="text"><span>Validación de video acuerdo</span>
                    <br>Comparación entre el rostro durante el video acuerdo y la foto de la ID</p>

                <div class="icon">
                    <div class="icon3"></div>
                </div>
                <p class="text"><span>Validación de video firma</span>
                    <br>Comparación entre el rostro durante la video firma y la foto de la ID</p>

                <div class="icon">
                    <div class="icon4"></div>
                </div>
                <p class="text"><span>Constancia Blockchain</span>
                    <br>Constancia escrita en Ethereum que garantiza que el documento firmado no será alterado.</p>

                <div class="icon">
                    <div class="icon5"></div>
                </div>
                <p class="text"><span>Captura de ID</span>
                    <br>Fotografía de documento de identidad por ambos lados</p>

                <div class="icon">
                    <div class="icon6"></div>
                </div>
                <p class="text"><span>OTP vía WhatsApp</span>
                    <br>Envío de código de un solo uso por WhatsApp, para que el firmante abra el documento a firmar en
                    la app FAD®</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Validación de firma</span>
                    <br>Comparación entre firma plasmada en la ID y la firma hecha con el dedo</p>

                <div class="icon">
                    <div class="icon7"></div>
                </div>
                <p class="text"><span>Versión WEB</span>
                    <br>El firmante puede realizar la firma de documentos desde cualquier navegador móvil sin descargar
                    la aplicación FAD®</p>

                <div class="icon">
                    <div class="icon20"></div>
                </div>
                <p class="text"><span style="color: #a80a34;">Consideraciones importantes</span>
                    <br>1. Para realizar las comparaciones de video acuerdo, videofirma y firma,
                    es necesario adquirir la Captura de identificación. <br>
                    2. Para la compra de Add-Ons solicítalos con tu asesor de ventas
                    con costo extra.</p>

                <img height="330px" width="266px" src="assets/images/m/telefonos.png" alt="">

            </div>

            <div class="box-light-fondo">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 10px;">
                        <p class="light">¿Deseas adquirir una <span>suscripción</span> mensual o un
                            <span>Plan Prepago</span> con vigencia anual?</p>
                    </div>
                    <div class="box-product">
                        <div class="content-res" style="padding-bottom: 10px;">
                            <p class="light" style="margin-bottom: 0px;">Suscripción</p><span>mensual</span>
                        </div>
                        <div class="buttons">
                            <div id="comprar_mensual_resumen_movil" class="btn-back" (click)="form(6)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                    <div class="box-product">
                        <div class="content-res" style="padding-bottom: 10px;">
                            <p class="light" style="margin-bottom: 0px;">Plan prepago con</p><span>vigencia anual</span>
                        </div>
                        <div class="buttons">
                            <div id="comprar_anual_resumen_movil" class="btn-back" (click)="form(7)">
                                <p>COTIZA HOY</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="contact-cotizar-movil">
            <div class="content-general-form" *ngIf="contactForm === 6 || contactForm === 7">
                <img class="close" (click)="contactForm = 0" src="assets/images/icon_cross.png" alt="Close">
                <div class="content-res-form" *ngIf="contactForm === 6">
                    <p class="title">Ayúdanos a completar el formulario para <strong>cotizar tu plan <br> de suscripción mensual
            </strong></p>
                </div>
                <div class="content-res-form" *ngIf="contactForm === 7">
                     <p class="title">Ayúdanos a completar el formulario para <strong>cotizar tu plan <br> de prepago con vigencia anual
            </strong></p>
                </div>
                <div class="content-res-form" *ngIf="contactForm === 6">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
                <div class="content-res-form" *ngIf="contactForm === 7">
                    <app-form-company-template [type]="contactForm"></app-form-company-template>
                </div>
            </div>
        </div>
    </div>

</app-template>
